import { HeartTwoTone } from "@ant-design/icons";
import { BackTop, Space } from "antd";
import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import React from "react";
import "./App.scss";
import { UserContextProvider } from "./auth/user-context-provider";
import YetteyFooter from "./components/yettey-footer/yettey-footer";
import YetteyHeader from "./components/yettey-header/yettey-header";
import MainPage from "./pages/main-page/main-page";
import { useMobileBreakpoint } from "./shared/hooks/mobile-hook";

function App() {
  const isMobile = useMobileBreakpoint(() => console.log("mobile vIew"));

  const firebaseConfig = {
    apiKey: "AIzaSyAi0g0alwQwktlA5Sz58LK2L-O6XMtGr4g",
    authDomain: "yettey-app.firebaseapp.com",
    databaseURL: "https://yettey-app.firebaseio.com",
    projectId: "yettey-app",
    storageBucket: "yettey-app.appspot.com",
    messagingSenderId: "745930857771",
    appId: "1:745930857771:web:afc4e0b48f548ac799f96e",
    measurementId: "G-YT4VYBYMMC",
  };

  const app = initializeApp(firebaseConfig);
  const analytics = getAnalytics(app);
  return (
    <UserContextProvider>
      <YetteyHeader isMobile={isMobile} />
      <MainPage />
      <BackTop />
      <Space className="w-100 d-flex justify-content-center">
        <span>
          Made with{" "}
          <HeartTwoTone twoToneColor="#eb2f96" className="heartbeat" /> by{" "}
          <a
            href="https://github.com/ramHruday/YetteY"
            target="_blank"
            rel="noopener noreferrer"
          >
            ThunderLions
          </a>
        </span>
      </Space>
      <YetteyFooter isMobile={isMobile} />
    </UserContextProvider>
  );
}

export default App;
